import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

export const formatDateTimeWithTimezone = (startDate, timezoneMap) => {
  const epochSeconds = startDate._seconds;

  const date = new Date(epochSeconds * 1000); // Convert Unix time to JavaScript Date

  // Check if date is valid
  if (isNaN(date.getTime())) {
    throw new Error("Invalid date for formatting");
  }

  const timeZone = timezoneMap.value; // Time zone from your API
  const offset = timezoneMap.offset; // Timezone offset in minutes

  // Create the timezone offset string in the format "+HH:MM"
  const offsetSign = offset < 0 ? "-" : "+";
  const offsetHours = Math.floor(Math.abs(offset) / 60);
  const offsetMinutes = Math.abs(offset) % 60;
  const offsetString = `${offsetSign}${String(offsetHours).padStart(
    2,
    "0"
  )}:${String(offsetMinutes).padStart(2, "0")}`;

  const zonedDate = utcToZonedTime(date, timeZone); // Convert the Date to the local time in the Beirut time zone

  const pattern = "yyyy-MM-dd'T'HH:mm:ss"; // Format you want for the output, includes "T" separator
  const formattedZonedDate = format(zonedDate, pattern, { timeZone }); // Format the zoned date

  // Replace "Z" with the offsetString to get the final datetime string in the required format
  const isoDateWithTimezone = formattedZonedDate.replace("Z", offsetString);

  return isoDateWithTimezone;
};
